import axios from '..';
import type { DebugLevel } from '../../../_configs/types';
import { type FaarenCarPricePlanList, type FaarenListCar } from '../../types/faaren';

export const getFaarenPriceList = async (faarenPricePlansUrl: FaarenListCar['uuid'], faarenApiKey: string, signal: AbortController['signal'], debug: DebugLevel): Promise<FaarenCarPricePlanList> => {
    const vehiclePricePlans = (
        await axios<{ data: FaarenCarPricePlanList[] }>({
            debug,
            method: 'get',
            url: faarenPricePlansUrl,
            headers: { Authorization: `Bearer ${faarenApiKey}` },
            signal,
        })
    )?.data?.data?.[0];

    return vehiclePricePlans;
};
